import { render } from "./categoryArticles.vue?vue&type=template&id=908807a4"
import script from "./categoryArticles.vue?vue&type=script&lang=js"
export * from "./categoryArticles.vue?vue&type=script&lang=js"

import "./categoryArticles.vue?vue&type=style&index=0&id=908807a4&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__